var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"for-rent-details fill-height transparent flex-fill d-flex justify-center"},[_c('HouseDetails',{attrs:{"header-panel":_vm.store.headerPanelForSale,"data":_vm.store.data.find(e => e.cod === this.$router.currentRoute.params.id),"store":_vm.store}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }